<template>
  <div :class="['mb-3', wrapperClass]">
    <label v-if="label" :for="selectId" class="form-label">{{ label }}</label>
    <select
      :id="selectId"
      v-model="innerValue"
      class="form-select"
      :class="[inputClass, { 'is-invalid': !!invalidFeedback }]"
      :disabled="disabled"
      @change="$emit('change', innerValue)"
    >
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="opt in normalizedOptions"
        :key="opt.value"
        :value="opt.value"
        :disabled="opt.disabled"
      >{{ opt.label }}</option>
    </select>
    <div v-if="invalidFeedback" class="invalid-feedback d-block">
      {{ invalidFeedback }}
    </div>
  </div>
</template>

<script>
let uid = 0

export default {
  name: 'AppSelect',
  props: {
    modelValue: { type: [String, Number, Array], default: '' },
    value: { type: [String, Number, Array], default: '' },
    options: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    disabled: Boolean,
    invalidFeedback: { type: String, default: '' },
    inputClass: { type: [String, Object, Array], default: '' },
    wrapperClass: { type: [String, Object, Array], default: '' },
    valueKey: { type: String, default: 'value' },
    labelKey: { type: String, default: 'label' },
    autoSelectFirst: { type: Boolean, default: true },
  },
  emits: ['update:modelValue', 'update:value', 'change'],
  data() {
    return {
      selectId: `app-select-${++uid}`,
    }
  },
  watch: {
    normalizedOptions: {
      handler(opts) {
        if (!this.autoSelectFirst) return
        const current = this.innerValue
        if (current !== undefined && current !== '') return
        const first = opts.find(o => !o.disabled && o.value !== '')
        if (first) this.innerValue = first.value
      },
      immediate: true,
    },
  },
  computed: {
    normalizedOptions() {
      return this.options.map(opt => {
        if (typeof opt === 'string' || typeof opt === 'number') {
          return { label: opt, value: opt }
        }
        if (typeof opt === 'object' && opt !== null) {
          return {
            label: opt[this.labelKey] || opt.label || opt.name || '',
            value: opt[this.valueKey] || opt.value || opt.id || '',
            disabled: !!opt.disabled,
          }
        }
        return { label: String(opt), value: opt }
      })
    },
    innerValue: {
      get() {
        const mv = this.modelValue
        if (mv !== undefined && mv !== '') return mv
        return this.value
      },
      set(val) {
        this.$emit('update:modelValue', val)
        this.$emit('update:value', val)
      },
    },
  },
}
</script>
